import { useQuery } from '@tanstack/react-query';
import { permissionsClient } from 'api/AdgangClients';
import { ResourceFilter, UserType } from 'api/adgang';
import { SelectOption } from 'common.ui';
import { concat } from 'helpers/concat';

export function usePermissionsQuery(params: {
  userType?: UserType;
  applicationIds?: string[];
  resourceFilter?: ResourceFilter;
}) {
  return useQuery({
    queryKey: ['permissions', params],
    queryFn: async () => {
      const applicationIds = params.applicationIds ?? [];
      const res = await permissionsClient.apiPermissionsSearchesPost({
        permissionSearchRequest: {
          paginationQuery: { pageNumber: 1, pageSize: 9999 },
          userType: params.userType,
          applicationFilter: {
            applicationIds: applicationIds.filter((a) => a !== 'global'),
            includeGlobalValues: applicationIds.includes('global')
          },
          resourceFilter: params.resourceFilter
        }
      });

      return (res.data ?? [])
        .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
        .map(
          (d) =>
            ({
              id: d.permissionId?.toString(),
              text: concat(' - ', d.name, d.description)
            }) as SelectOption
        );
    },
    staleTime: 5 * 60 * 1000
  });
}
